export default __webpack_public_path__ + "static/media/location-track-email.fa4e8c67.svg";